import { render, staticRenderFns } from "./choose-word.vue?vue&type=template&id=7a383164&"
import script from "./choose-word.vue?vue&type=script&lang=js&"
export * from "./choose-word.vue?vue&type=script&lang=js&"
import style0 from "./choose-word.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports